export default __webpack_public_path__ + "static/media/wheel-button.7c6f188f.svg";